import { Injectable } from '@angular/core';

@Injectable()
export class EventUtilService {

    public getStatusBadgeClass(status: string): string {
        switch (status) {
          case 'PUBLISHED':
            return 'bg-success';
          case 'CANCELLED':
            return 'bg-warning';
          case 'EXECUTED':
            return 'bg-info';
          case 'DRAFT':
            return 'bg-danger';
          default:
            return 'bg-secondary';
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event.util.service.ts